import React from 'react';
import { LinkItem } from '@atlaskit/menu';
import { NavigationLink } from '@css-xp/graphtypes';
import { ImgIcon } from './navigation-menu';

export const NavLinkItem = ({ link }: { link: NavigationLink }) => {
  return (
    <LinkItem
      href={link.url ?? ''}
      target="_blank"
      iconBefore={<ImgIcon src={link?.iconUrl ?? ''} alt={`Icon for: ${link?.name}`} />}
    >
      {link?.name}
    </LinkItem>
  );
};
